import { gql } from '@apollo/client';
const ADD_TENANT_SEASON = gql `
  mutation AddTenantSeason($tenantId: ID!, $name: String!) {
    addSeason(tenantId: $tenantId, name: $name) {
      season {
        id
        name
        workingSeason
        canNameBeUpdated
        canBeRemoved
      }
    }
  }
`;
export default ADD_TENANT_SEASON;
